import Cookies from "js-cookie";
import API from "../../utils/endpoints";
import * as types from "./actionType";
import history from "../../history";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getAuthenticationCookie,
  setAuthenticationCookie,
} from "../../utils/authentication";

const errorMessage = {
  status: 400,
  message: "Something went wrong",
};

function pieChartStatistics() {
  return {
    type: types.PIE_CHART_STATISTICS,
  };
}

function pieChartStatisticsSuccess(payload) {
  return {
    type: types.PIE_CHART_STATISTICS_SUCCESS,
    payload,
  };
}

function pieChartStatisticsFailed(payload) {
  return {
    type: types.PIE_CHART_STATISTICS_FAILED,
    payload,
  };
}

function customerStatistics() {
  return {
    type: types.CUSTOMER_STATISTICS,
  };
}

function customerStatisticsSuccess(payload) {
  return {
    type: types.CUSTOMER_STATISTICS_SUCCESS,
    payload,
  };
}

function customerStatisticsFailed(payload) {
  return {
    type: types.CUSTOMER_STATISTICS_FAILED,
    payload,
  };
}
function eventsStatistics() {
  return {
    type: types.EVENTS_STATISTICS,
  };
}

function eventsStatisticsSuccess(payload) {
  return {
    type: types.EVENTS_STATISTICS_SUCCESS,
    payload,
  };
}

function eventsStatisticsFailed(payload) {
  return {
    type: types.EVENTS_STATISTICS_FAILED,
    payload,
  };
}
function ridesStatistics() {
  return {
    type: types.RIDES_STATISTICS,
  };
}

function ridesStatisticsSuccess(payload) {
  return {
    type: types.RIDES_STATISTICS_SUCCESS,
    payload,
  };
}

function ridesStatisticsFailed(payload) {
  return {
    type: types.RIDES_STATISTICS_FAILED,
    payload,
  };
}

export const fetchPieChartStatistics = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(pieChartStatistics());
  try {
    let response = await api.get(
      `${API.analytics}?countryCode=${payload.country}&startDate=${payload.startDate}&endDate=${payload.endDate}`
    );

    if (response.data.code === 200) {
      dispatch(pieChartStatisticsSuccess(response.data.data));
    } else {
      dispatch(pieChartStatisticsFailed(response.data));
    }
  } catch (error) {
    dispatch(pieChartStatisticsFailed(errorMessage));
  }
};

export const fetchCustomerStatistics = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(customerStatistics());
  try {
    let response = await api.get(
      `${API.customerAnalytics}?countryCode=${payload.country}&startDate=${payload.startDate}&endDate=${payload.endDate}`
    );

    if (response.data.code === 200) {
      dispatch(customerStatisticsSuccess(response.data.data));
    } else {
      dispatch(customerStatisticsFailed(response.data));
    }
  } catch (error) {
    dispatch(customerStatisticsFailed(errorMessage));
  }
};

export const fetchEventsStatistics = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(eventsStatistics());
  try {
    let response = await api.get(
      `${API.eventsAnalytics}?countryCode=${payload.country}&startDate=${payload.startDate}&endDate=${payload.endDate}`
    );

    if (response.data.code === 200) {
      dispatch(eventsStatisticsSuccess(response.data.data));
    } else {
      dispatch(eventsStatisticsFailed(response.data));
    }
  } catch (error) {
    dispatch(eventsStatisticsFailed(errorMessage));
  }
};

export const fetchRidesStatistics = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(ridesStatistics());
  try {
    let response = await api.get(
      `${API.ridesAnalytics}?countryCode=${payload.country}&startDate=${payload.startDate}&endDate=${payload.endDate}`
    );

    if (response.data.code === 200) {
      dispatch(ridesStatisticsSuccess(response.data.data));
    } else {
      dispatch(ridesStatisticsFailed(response.data));
    }
  } catch (error) {
    dispatch(ridesStatisticsFailed(errorMessage));
  }
};
